<form [formGroup]="addressForm" novalidate>
  <div class="row mb-3">
    <div class="col-6">
      <label for="postal_code" class="form-label">CEP/Código Postal</label>

      <div class="position-relative">
        <input
          type="text"
          class="form-control pe-5"
          id="postal_code"
          formControlName="postal_code"
          placeholder="00000-000"
          [mask]="isBrazilianCostumer ? '00000-000' : null"
          [readonly]="isLoadingCep"
          [class.loading-field]="isLoadingCep"
          [class.is-invalid]="addressForm.get('postal_code')?.invalid && addressForm.get('postal_code')?.touched" />

        @if (isLoadingCep) {
          <div class="position-absolute top-50 end-0 translate-middle-y pe-2 input-spinner">
            <div class="spinner-border spinner-border-sm text-secondary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
        }
      </div>

      @if (addressForm.get("postal_code")?.invalid && addressForm.get("postal_code")?.touched) {
        <div class="invalid-feedback">O campo CEP é obrigatório.</div>
      }
    </div>

    <div class="col-6">
      <label for="state" class="form-label">Estado</label>
      @if (isBrazilianCostumer && !isLoadingCep) {
        <select
          class="form-select"
          id="state"
          formControlName="state"
          [class.is-invalid]="addressForm.get('state')?.invalid && addressForm.get('state')?.touched">
          @for (state of brazilianStates; track state.id) {
            <option [value]="state.abbr">{{ state.name }}</option>
          }
        </select>
      } @else {
        <input
          type="string"
          id="state"
          formControlName="state"
          class="form-control"
          placeholder="Informe as siglas do Estado"
          [readonly]="isLoadingCep"
          [class.loading-field]="isLoadingCep"
          [class.is-invalid]="addressForm.get('state')?.invalid && addressForm.get('state')?.touched" />
      }
      <div class="invalid-feedback">
        @if (addressForm.get("state")?.hasError("required")) {
          Informe um estado
        } @else if (addressForm.get("state")?.hasError("maxlength")) {
          O estado só pode ter no máximo 6 digitos.
        }
      </div>
    </div>
  </div>
  @if (isLoadingCep) {
    <div id="cepHelp" class="form-text alert alert-info">Buscando dados de endereço do CEP fornecido.</div>
  }

  <div class="form-group form-group-columns">
    <div class="mb-3 flex-grow-1">
      <label for="city_name" class="form-label">Cidade</label>
      <input
        type="text"
        class="form-control"
        id="city_name"
        formControlName="city_name"
        placeholder="Digite a cidade"
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep"
        [class.is-invalid]="addressForm.get('city_name')?.invalid && addressForm.get('city_name')?.touched" />
      <div class="invalid-feedback">O campo de cidade é obrigatório e aceita somente letras.</div>
    </div>

    <div class="mb-3" style="min-width: 240px">
      <label for="district" class="form-label">Bairro/Distrito</label>
      <input
        type="text"
        class="form-control"
        id="district"
        formControlName="district"
        placeholder="Digite o bairro"
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep"
        [class.is-invalid]="addressForm.get('district')?.invalid && addressForm.get('district')?.touched" />
      @if (addressForm.get("district")?.invalid && addressForm.get("district")?.touched) {
        <div class="invalid-feedback">O campo bairro é obrigatório.</div>
      }
    </div>
  </div>

  <div class="mb-3">
    <label for="street" class="form-label">Rua</label>
    <input
      type="text"
      class="form-control"
      id="street"
      formControlName="street"
      placeholder="Digite o nome da rua"
      [readonly]="isLoadingCep"
      [class.loading-field]="isLoadingCep"
      [class.is-invalid]="addressForm.get('street')?.invalid && addressForm.get('street')?.touched" />
    @if (addressForm.get("street")?.invalid && addressForm.get("street")?.touched) {
      <div class="invalid-feedback">O campo rua é obrigatório.</div>
    }
  </div>

  <div class="row mb-3">
    <div class="col-6">
      <label for="number" class="form-label">Número</label>
      <input
        type="text"
        class="form-control"
        id="number"
        formControlName="number"
        placeholder="123"
        [class.is-invalid]="addressForm.get('number')?.invalid && addressForm.get('number')?.touched" />
      @if (addressForm.get("number")?.invalid && addressForm.get("number")?.touched) {
        <div class="invalid-feedback">O campo número é obrigatório.</div>
      }
    </div>
    <div class="col-6">
      <label for="additional_information" class="form-label">Complemento</label>
      <input
        type="text"
        class="form-control"
        id="additional_information"
        formControlName="additional_information"
        placeholder="Apt, casa, etc."
        [readonly]="isLoadingCep"
        [class.loading-field]="isLoadingCep" />
    </div>
  </div>
</form>
<div class="actions">
  <app-button styleType="success" [disabled]="this.loading" (btnClick)="saveAddressClick()">
    {{ this.loading ? "Carregando..." : "Salvar endereço e continuar" }}
  </app-button>
  <app-button
    styleType="clean"
    [disabled]="this.loading || !hasAddress()"
    matTooltip="Necessário cadastrar um endereço antes de finalizar a compra"
    [matTooltipDisabled]="hasAddress()"
    (btnClick)="continueWithoutChangesClick()">
    Continuar sem alterar
  </app-button>
</div>
